import { Card, Checkbox, Col, Form, Input, Row, Select } from "antd";
import React, { useState } from "react";

import FormAction from "../../../../../../components/common/FormAction";

import { CgCloseO } from "react-icons/cg";
import { RiAddCircleFill } from "react-icons/ri";
import { BiMessageRounded } from "react-icons/bi";
import { FiMail } from "react-icons/fi";

import { numberType } from "../../../../../../utils/tenants";
import { salutation } from "../../../../../../utils/tenants";

import "./Contact.css";

function Contact({ data }) {
  const [checked, setChecked] = useState(false);

  const [phoneNumbers, setPhoneNumbers] = useState([
    { number: "", type: "", detail: "" },
  ]);
  const [emails, setEmails] = useState([{ email: "" }]);

  const addAnotherEmail = () => {
    setEmails([...emails, { email: "" }]);
  };

  const onRemoveEmail = (index) => {
    const newEmails = [...emails];
    newEmails.splice(index, 1);
    setEmails(newEmails);
  };

  const addAnotherNumber = () => {
    setPhoneNumbers([...phoneNumbers, { number: "", type: "", detail: "" }]);
  };

  const onRemoveNumber = (index) => {
    const newNumbers = [...phoneNumbers];
    newNumbers.splice(index, 1);
    setPhoneNumbers(newNumbers);
  };

  const onCancel = () => {
    setChecked(false);
  };
  return (
    <Card
      title="Contact"
      extra={
        !checked ? (
          <span className="onclick-text" onClick={() => setChecked(true)}>
            Edit
          </span>
        ) : null
      }
    >
      {checked ? (
        <Form colon={false} labelCol={{ span: 5 }} >
          <Row gutter={[0, 8]} justify="center">
            <Col span={16}>
              <Form.Item label="Salutation">
                <Select options={salutation} />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Legal First Name" required>
                <Input />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Middle Name" required>
                <Input />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label=" ">
                <Checkbox>
                  I certify the applicant did not provide a middle name
                </Checkbox>
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Last Name">
                <Input />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Suffixes">
                <Input placeholder="Jr Sr III IV" />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Applicant Type">
                <Select
                  options={[
                    { value: "Financially Responsilbe" },
                    { value: "Co-signer" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label="Company Name">
                <Input />
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item label=" ">
                <Checkbox>Use Company Name as display name</Checkbox>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[0, 16]}>
            <Col span={24}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <strong>Phone Numbers</strong>
                </Col>
                <Col span={24}>
                  <Row gutter={[0, 8]}>
                    {phoneNumbers.map((item, index) => {
                      return (
                        <Col span={24}>
                          <Row align="middle" gutter={[24, 0]}>
                            <Col span={23}>
                              <Row gutter={[0, 8]}>
                                <Col span={24}>
                                  <Row gutter={[8, 0]}>
                                    <Col span={16}>
                                      <Form.Item>
                                        <Input style={{ width: "100%" }} />
                                      </Form.Item>
                                    </Col>
                                    <Col span={8}>
                                      <Form.Item>
                                        <Select
                                          options={numberType}
                                          placeholder="Select"
                                          style={{ width: "100%" }}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col span={24}>
                                  <Form.Item>
                                    <Input
                                      placeholder="Description"
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Item>
                                </Col>
                              </Row>
                            </Col>
                            <Col
                              className="number-delete"
                              onClick={() => onRemoveNumber(index)}
                              span={1}
                            >
                              <CgCloseO size={18} />
                            </Col>
                          </Row>
                        </Col>
                      );
                    })}
                    <Col span={24}>
                      <button
                        className="add-icon-btn"
                        onClick={() => addAnotherNumber()}
                      >
                        <RiAddCircleFill size={18} />
                        Add Another Phone Number
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row gutter={[0, 8]}>
                <Col span={24}>
                  <strong>Emails</strong>
                </Col>
                <Col span={24}>
                  <Row gutter={[0, 8]}>
                    {emails.map((item, index) => {
                      return (
                        <Col span={24} key={index}>
                          <Row justify="space-between" align="middle" gutter={[24, 0]}>
                            <Col span={23}>
                              <Form.Item>
                                <Input style={{ width: "100%" }} />
                              </Form.Item>
                            </Col>
                            {emails.length > 1 ? (
                              <Col
                                span={1}
                                onClick={() => onRemoveEmail(index)}
                                className="email-delete"
                              >
                                <CgCloseO size={18} />
                              </Col>
                            ) : null}
                          </Row>
                        </Col>
                      );
                    })}
                    <Col span={24}>
                      <button
                        className="add-icon-btn"
                        onClick={() => addAnotherEmail()}
                      >
                        <RiAddCircleFill size={18} />
                        Add Another Phone Number
                      </button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <FormAction className="contact-actions" cancel={onCancel} />
            </Col>
          </Row>
        </Form>
      ) : (
        <Row gutter={[0, 8]} className="contact-form">
          <Col span={24}>
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <strong>Phone Numbers</strong>
              </Col>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                >
                  <Form.Item label="Mobile">
                    <div className="mobile-container">
                      <p className="onclick-text">
                        {data?.phoneNumbers
                          ? data.phoneNumbers[0].number
                          : null}
                      </p>
                      <button className="icon-btn">
                        <BiMessageRounded size={16} />
                        <span>Text</span>
                      </button>
                    </div>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row gutter={[0, 8]}>
              <Col span={24}>
                <strong>Emails</strong>
              </Col>
              <Col span={24}>
                <Form
                  colon={false}
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 11 }}
                >
                  <Form.Item label="Email">
                    <div className="email-container">
                      <p className="onclick-text">
                        {data?.emails ? data.emails[0].email : null}
                      </p>
                      <button className="icon-btn">
                        <FiMail size={16} />
                        <span>Email</span>
                      </button>
                    </div>
                  </Form.Item>
                  <Form.Item label="Type">{data?.type}</Form.Item>
                </Form>
              </Col>
            </Row>
          </Col>
        </Row>
      )}
    </Card>
  );
}

export default Contact;
